export default __webpack_public_path__ + "static/media/budget.29561ac2.svg";